<template>
    <section class="inner">
        <div class="left">
            <div class="top">
                <icon-title title="党建" iconName="kjtzbxueke"></icon-title>
                <div class="item-top">
                    <div class="chart" id="chart1T"></div>
                </div>
                <div class="item-bottom">
                    <div class="chart chart2" id="chart1L"></div>
                    <div class="chart chart2" id="chart1R"></div>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="智库-学会开展决策咨询工作情况" iconName="wenben"></icon-title>
                <div class="chart" id="chart2"></div>
            </div>
        </div>
        <div class="center">
            <div class="top">
                <icon-title title="数字图书馆" class="lg" iconName="lunwen"></icon-title>
                <div class="item-top">
                    <div class="chart" id="chart3T"></div>
                </div>
                <div class="item-bottom">
                    <div class="chart chart2" id="chart3L"></div>
                    <div class="chart chart2" id="chart3R"></div>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="数字图书馆" class="lg" iconName="lunwen"></icon-title>
                <div class="chart chart2" id="chart4L"></div>
                <div class="chart chart2" id="chart4R"></div>
            </div>
        </div>
        <div class="right">
            <div class="top">
                <icon-title title="学术" iconName="gnwyzb"></icon-title>
                <div class="item-top">
                    <div class="chart" id="chart5T"></div>
                </div>
                <div class="item-bottom">
                    <div class="chart" id="chart5R"></div>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="科普-学会举办科普活动情况" iconName="jinxianshibutong"></icon-title>
                <div class="chart" id="chart6"></div>
            </div>
        </div>
    </section>
</template>
<script>
    import IconTitle from '@/components/icontitle';
    import * as dataJS from '@/assets/scripts/api/ybj';

    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const barColor = [ '#06C0FB', '#2F46C1', '#FB058F', '#EF9412', '#30CF6F','#30CF70'];
    const pieColor = [
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        },
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        },
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        }
    ];
    const xAxis = {
        type: 'category',
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 14
            }
        },
        axisLine: {
            lineStyle: {
                color: lineColor
            }
        },
        splitLine: {
            show: false
        },
        axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
                color: lineColor,
            }
        }
    };
    const YAXIS = {
        axisTick: {
            show: false
        },
        axisLine: {
            show: false
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: lineColor,
                type: 'dotted'
            }
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 12
            },
            formatter: '{value}'
        }
    };

    export default {
        name: 'djgc',
        components: {
            IconTitle
        },
        data() {
            return {};
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

                // 党建
                dataJS.getDparty().then((res) => {
                    this.initChart1(res.data);
                });

                // 智库
                dataJS.getDidea().then((res) => {
                    this.initChart2(res.data);
                });

                // 数字图书馆
                dataJS.getDlibrary().then((res) => {
                    this.initChart3(res.data);
                    this.initChart4(res.data);
                });

                // 学术
                dataJS.getDscholarism().then((res) => {
                    this.initChart5(res.data);
                });

                // 科普-学会举办科普活动情况
                dataJS.getDkepu().then((res) => {
                    this.initChart6(res.data);
                });

            },
            initChart1(data) {
                let chart1T = echarts.init(document.getElementById('chart1T')),
                    optionT = this.getBarData(data.edu, '党员学历分布', 'bar1', true, ''),
                    chartL = echarts.init(document.getElementById('chart1L')),
                    optionL = this.getPieOption(data.action, '党员活动类型分布'),
                    chartR = echarts.init(document.getElementById('chart1R')),
                    optionR = this.getPieOption(data.office, '党员任职分布');

                chart1T.setOption(optionT, true);
                chart1T.resize();
                this.$winResize(chart1T.resize);
                chartL.setOption(optionL, true);
                chartL.resize();
                this.$winResize(chartL.resize);
                chartR.setOption(optionR, true);
                chartR.resize();
                this.$winResize(chartR.resize);
            },
            initChart2(data) {
                let chart = echarts.init(document.getElementById('chart2')),
                    option = this.getBarData(data.edu, '', 'complex', true);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3(data) {
                let chart3L = echarts.init(document.getElementById('chart3L')),
                    chart3T = echarts.init(document.getElementById('chart3T')),
                    optionL = this.getBarData(data.two, '各应用模块浏览量', 'bar', true),
                    chart3R = echarts.init(document.getElementById('chart3R')),
                    optionR = this.getBarData(data.three, '各应用模块资料数量', 'bar', true),
                    optionT = this.getLineData(data.one, '资料收录和用户浏览情况', 'area');

                chart3L.setOption(optionL, true);
                chart3L.resize();
                this.$winResize(chart3L.resize);
                chart3R.setOption(optionR, true);
                chart3R.resize();
                this.$winResize(chart3R.resize);
                chart3T.setOption(optionT, true);
                chart3T.resize();
                this.$winResize(chart3T.resize);
            },
            initChart4(data) {
                let chart4L = echarts.init(document.getElementById('chart4L')),
                    optionL = this.getRadarOption(data.four, '各应用模块平均每件资料浏览量'),
                    chart4R = echarts.init(document.getElementById('chart4R')),
                    optionR = this.getRadarOption(data.five, '各应用模块用户收藏数');

                chart4L.setOption(optionL, true);
                chart4L.resize();
                this.$winResize(chart4L.resize);
                chart4R.setOption(optionR, true);
                chart4R.resize();
                this.$winResize(chart4R.resize);
            },
            initChart5(data) {
                let chart5T = echarts.init(document.getElementById('chart5T')),
                    chart5R = echarts.init(document.getElementById('chart5R')),
                    optionT = this.getBarData(data.one, '学会举办的各类学术活动情况', 'complex', true),
                    optionR = this.getLineData(data.two, '奖项受理和获奖情况');

                chart5T.setOption(optionT, true);
                chart5T.resize();
                this.$winResize(chart5T.resize);
                chart5R.setOption(optionR, true);
                chart5R.resize();
                this.$winResize(chart5R.resize);
            },
            initChart6(data) {
                let chart6 = echarts.init(document.getElementById('chart6')),
                    option = this.getBarData(data, '', 'complex', true);

                chart6.setOption(option, true);
                chart6.resize();
                this.$winResize(chart6.resize);
            },
            getLineData(data, title) {
                let seriesData = [],
                    option;

                data.list.forEach((item, index) => {

                    seriesData.push({
                        name: data.title[index],
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
                        itemStyle: {
                            normal: {
                                color: pieColor[index].line,
                                lineStyle: {
                                    color: pieColor[index].line
                                }
                            },
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: pieColor[index].line
                                }, {
                                    offset: 1,
                                    color: pieColor[index].area
                                }])
                            }
                        },
                        data: item
                    });
                });

                option = {
                    title: {
                        text: title,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: '5%',
                        left: '5%'
                    },
                    color: barColor,
                    grid: {
                        left: '3%',
                        right: '3%',
                        top: title ? '20%' : '10%',
                        bottom: '17%',
                        containLabel: true
                    },
                    legend: {
                        itemWidth: 15,
                        itemHeight: 15,
                        data: data.title,
                        bottom: 0,
                        icon: 'rect',
                        textStyle: {
                            color: labelColor
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: Object.assign({
                        data: data.column
                    }, xAxis),
                    yAxis: YAXIS,
                    series: seriesData
                };

                return option;

            },
            getBarData(data, title, type) {
                let seriesData = [],
                    option,
                    YAxis = YAXIS;

                switch (type) {
                case 'complex':
                    YAxis = this.returnComplexData(data).yAxis;
                    seriesData = this.returnComplexData(data).seriesData;
                    break;
                case 'bar':
                    seriesData = this.returnBarData(data, '60%');
                    break;
                case 'bar1':
                    seriesData = this.returnBarData(data, '25%');
                    break;
                }

                option = {
                    title: {
                        text: title,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: '5%',
                        left: '5%'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        top: title ? '25%' : '10%',
                        bottom: type == 'bar' ? '5%' : '10%',
                        containLabel: true
                    },
                    legend: {
                        bottom: 0,
                        data: data.title,
                        itemWidth: 15,
                        itemHeight: 15,
                        textStyle: {
                            color: labelColor
                        }
                    },
                    xAxis: Object.assign({
                        data: data.column
                    }, xAxis),
                    yAxis: YAxis,
                    series: seriesData
                };

                return option;
            },
            returnBarData(data, barWidth) {
                let seriesData = data.list.map((item, index) => {
                    return {
                        type: 'bar',
                        barWidth: barWidth,
                        barGap: 1,
                        name: data.title[index],
                        itemStyle: {
                            normal: {
                                show: true,
                                color: barColor[index]
                            }
                        },
                        data: item
                    };

                });

                return seriesData;
            },
            returnComplexData(data) {
                let seriesData = [],
                    yAxis,
                    max1 = Math.max.apply(null, data.list[0]),
                    max2 = Math.max.apply(null, data.list[1]);

                seriesData = [
                    {
                        name: data.title[0],
                        type: 'bar',
                        barWidth: '25%',
                        itemStyle: {
                            normal: {
                                color: barColor[0]
                            }
                        },
                        yAxisIndex: 0,
                        data: data.list[0]
                    },
                    {
                        name: data.title[1],
                        type: 'line',
                        symbol: 'none',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: barColor[2]
                            }
                        },
                        yAxisIndex: 1,
                        data: data.list[1]
                    }];

                yAxis = [
                    Object.assign({
                        type: 'value',
                        min: 0,
                        max: max1,
                    }, YAXIS),
                    Object.assign({
                        type: 'value',
                        min: 0,
                        max: max2
                    }, YAXIS)
                ];

                return {seriesData, yAxis};
            },
            getRadarOption(data, title) {
                let indicatorData = this.getchartData(data),
                    option = {},
                    lengendData = [],
                    selectedData = {};

                let seriesData = data.list.map((item, index) => {

                    lengendData.push({
                        name: data.title[index],
                        icon: 'circle',
                        textStyle: {
                            color: labelColor,
                            margin: 7
                        }
                    })

                    selectedData[data.title[index]] = index < 2 ? true : false;

                    return {
                        type: 'radar',
                        name: data.title[index],
                        data: [item],
                        symbolSize: 8,
                        lineStyle: {
                            color: pieColor[index].line
                        },
                        areaStyle: {
                            color: pieColor[index].line,
                            opacity: 0.5
                        },
                        itemStyle: {
                            color:pieColor[index].line,
                            borderWidth: 2
                        }
                    }
                })

                option = {
                    title: {
                        text: title,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: '3%',
                        left: '5%'
                    },
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 6,
                        itemHeight: 6,
                        itemGap: 20,
                        bottom: '3%',
                        selected: selectedData,
                        data: lengendData
                    },
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    radar: {
                        radius: '55%',
                        center: ['50%', '60%'],
                        splitNumber: 2,
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        splitArea: false,
                        splitLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        name: {
                            textStyle: {
                                color: labelColor,
                                padding: [3, 5]
                            }
                        },
                        indicator: indicatorData
                    },
                    series: seriesData
                };

                return option;
            },
            getchartData(data) {
                let indicatorData = [];

                let numData = data.list.map((item) => {
                    return Math.max.apply(null, item);
                })

                data.column.forEach((item) => {
                    let max = Math.max.apply(null, numData),
                        obj = {
                            name: item,
                            max: max
                        };

                    indicatorData.push(obj);
                });

                return indicatorData;
            },
            getPieOption(data, name) {
                let seriesData = [],
                    option = {};

                data.list.forEach((item, index) => {
                    let obj = {};

                    obj.value = parseFloat(item);
                    obj.name = data.column[index];

                    if (index == 0) {
                        obj.selected = true;
                    }
                    seriesData.push(obj);
                });

                option = {
                    tooltip: {
                        trigger: 'item'
                    },
                    title: {
                        text: name,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: 0,
                        left: '5%'
                    },
                    grid: {
                        left: '0',
                        right: '0',
                        bottom: '13%',
                        top: '20%',
                        containLabel: true
                    },
                    color: barColor,
                    series: [{
                        name: '',
                        type: 'pie',
                        radius: [0, '60%'],
                        center: ['50%', '60%'],
                        label: {
                            show: false
                        },
                        data: seriesData
                    }]
                };

                return option;
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "~@/assets/scss/mixins/_mixins.scss";

    $titleColor: #B5C8FF;
    $borderColor: #17215F;
    $borderDrakColor: #080B26;

    .inner {
        padding: 2% 2.08% 0;
        font-size:.16rem;

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .top {
            height: 50%;
        }

        .bottom {
            height: 50%;
        }

        .left {
            float: left;
            width: 26.8%;
            height: 100%;

        }

        .right {
            @extend .left;
            float: right;
        }

        .center {
            float: left;
            width: 43%;
            height: 100%;
            margin: 0 1.6%;
        }

        .top {
            height: 56.8%;
        }

        .bottom {
            height: 39.1%;
        }

        .item-top{
            width:100%;
            height: 50%;
        }

        .item-bottom{
            width:100%;
            height: calc(50% - 34px);
        }


        .chart {
            width: 100%;
            height: 100%;
        }

        .chart2{
            width:50%;
            float: left;
        }
    }

</style>